// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"2da27cbd117002c0280c","678":"23b391d7177efa8f12f8","883":"36ef09b103edd54e1b6a"}[chunkId] + ".js";
};